<template>
    <div class="pa-4 fill-height d-flex flex-column flex-grow-1">
        <AgGrid class="flex-grow-1" ref="logAppointmentAgGridRef" :fetchUrl="logAppointmentFetchUrl" 
        :columnDefs="logAppointmentColDefs" :gridParams="logAppointmentGridParams" :ssrm="true" :ssrmBlockSize="50"/>
    </div>
</template>

<script setup>
    
    //Grid data binded through SSRM
    //const serverSideDatasource in AgGrid.vue

    import { inject, ref, useTemplateRef } from 'vue';
    import AgGrid from '@/components/AgGrid.vue';
    import { useUserStore } from '@/stores/userStore';

    const props = defineProps({
        customerReference: {
            type: String,
            default: null,
        },
    });
    const emit = defineEmits(['pending-changes']);
    
    const urlWebAPI = inject('urlWebAPI');
    const translate = inject('translate');
    const userStore = useUserStore();
    const logAppointmentGridRef = useTemplateRef('logAppointmentAgGridRef');

    const logAppointmentFetchUrl = 'GetLogAppointment';
    const logAppointmentColDefs = [
        {
            field: 'id',
            headerName: 'id',
            suppressHeaderMenuButton: true,
            hide: true
        },
        {
            field: 'userId',
            headerName: 'user Id',
            suppressHeaderMenuButton: true,
            hide: true,
        },
        {
            field: 'userReference',
            headerName: translate('userName', 'column'),
            suppressHeaderMenuButton: true
        },
        {
            field:'userFirstName',
            headerName: translate('firstName', 'column'),
            suppressHeaderMenuButton: true
        },
        {
            field:'userLastName',
            headerName: translate('lastName', 'column'),
            suppressHeaderMenuButton: true
        },

        {
            field: 'logDate',
            headerName: 'Log Date',
            suppressHeaderMenuButton: true,
            type: 'date'
        },
        {
            field: 'appointmentUid',
            headerName: 'appointmentUid',
            suppressHeaderMenuButton: true,
            hide: true
        },
        {
            field: 'message',
            headerName: translate('shortMsg', 'column'),
            suppressHeaderMenuButton: true
        },
        {
            field: 'data',
            headerName: 'Data',
            type: 'appointmentAction',
            suppressHeaderMenuButton: true
        }
    ];

    const logAppointmentGridParams = {
        token: userStore.getUser().token,
        customerReference: props.customerReference
    };



</script>